
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Footer = () => {
  const { t, i18n } = useTranslation();

  const cleaningLinks = [
    { slug: "residential-cleaning", en: "Residential Cleaning", es: "Limpieza Residencial" },
    { slug: "deep-cleaning", en: "Deep Cleaning", es: "Limpieza Profunda" },
    { slug: "move-in-out-cleaning", en: "Move-in / Move-out", es: "Limpieza de Mudanza" },
    { slug: "airbnb-cleaning", en: "Airbnb Cleaning", es: "Limpieza Airbnb" },
  ];

  const handymanLinks = [
    { slug: "drywall-repair", en: "Drywall Repair", es: "Reparación de Drywall" },
    { slug: "interior-painting", en: "Interior Painting", es: "Pintura Interior" },
    { slug: "pressure-washing", en: "Pressure Washing", es: "Lavado a Presión" },
    { slug: "tv-mounting", en: "TV Mounting", es: "Instalación de TV" },
  ];

  const lang = i18n.language;

  return (
    <footer className="bg-brand-beige border-t border-gray-200">


      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4 cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/bbc9d585-3730-407a-ad80-463c6844ded8/016cccb4-6d9f-42db-b639-40ff0b2a2b7e_adry.png?v=d8b4f5cb5cb55fdf4705f60bba5131a8"
                alt="Adry & Mich Logo"
                className="w-12 h-12 object-contain rounded-full"
              />
              <div>
                <p className="font-heading font-bold text-brand-dark text-sm">Adry &amp; Mich</p>
                <p className="font-body text-xs text-brand-green">Cleaning &amp; Handyman</p>
              </div>
            </Link>
            <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">{t("footer.tagline")}</p>
            <div className="flex flex-col gap-1.5">
              <a href="tel:+15612626118" className="flex items-center gap-2 text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer">
                <i className="ri-phone-line text-brand-green"></i>
                (561) 262-6118
              </a>
              <a href="mailto:adrimich7778@hotmail.com" className="flex items-center gap-2 text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer">
                <i className="ri-mail-line text-brand-green"></i>
                adrimich7778@hotmail.com
              </a>
            </div>
          </div>

          {/* Cleaning Services */}
          <div>
            <h4 className="font-heading font-semibold text-brand-dark text-sm mb-4">
              {lang === "en" ? "Cleaning Services" : "Servicios de Limpieza"}
            </h4>
            <ul className="flex flex-col gap-2">
              {cleaningLinks.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/services/${l.slug}`}
                    className="font-body text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer"
                  >
                    {lang === "en" ? l.en : l.es}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Handyman Services */}
          <div>
            <h4 className="font-heading font-semibold text-brand-dark text-sm mb-4">
              {lang === "en" ? "Handyman Services" : "Servicios de Reparación"}
            </h4>
            <ul className="flex flex-col gap-2">
              {handymanLinks.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/services/${l.slug}`}
                    className="font-body text-sm text-gray-600 hover:text-brand-navy transition-colors cursor-pointer"
                  >
                    {lang === "en" ? l.en : l.es}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="font-body text-sm text-brand-green hover:text-brand-green-dark transition-colors cursor-pointer font-medium">
                  {lang === "en" ? "View all →" : "Ver todos →"}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Contact */}
          <div>
            <h4 className="font-heading font-semibold text-brand-dark text-sm mb-4">{t("footer.company")}</h4>
            <ul className="flex flex-col gap-2 mb-5">
              <li><Link to="/about" className="font-body text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer">{t("nav.about")}</Link></li>
              <li><Link to="/testimonials" className="font-body text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer">{t("nav.testimonials")}</Link></li>
              <li><Link to="/contact" className="font-body text-sm text-gray-600 hover:text-brand-green transition-colors cursor-pointer">{t("nav.contact")}</Link></li>
            </ul>
            <div className="flex flex-col gap-1.5">
              <p className="font-body text-xs text-gray-500">
                <i className="ri-time-line mr-1 text-brand-green"></i>
                {t("footer.schedule")}
              </p>
              <p className="font-body text-xs text-gray-500">
                <i className="ri-bank-card-line mr-1 text-brand-green"></i>
                {t("footer.payment")}
              </p>
              <p className="font-body text-xs text-gray-500">
                <i className="ri-map-pin-line mr-1 text-brand-green"></i>
                Royal Palm Beach, FL 33411
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-3">
            <p className="font-body text-xs text-gray-500">{t("footer.rights")}</p>
            <span className="text-gray-300 hidden sm:inline">|</span>
            <a
              href="https://crescendodigitalmarketingagency.com/en/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 cursor-pointer group"
            >
              <span className="font-body text-xs text-gray-400 group-hover:text-brand-green transition-colors whitespace-nowrap">Marketing by</span>
              <img
                src="https://storage.readdy-site.link/project_files/bbc9d585-3730-407a-ad80-463c6844ded8/cca613f4-dc02-4baf-9700-32cf9ce2b693_Agrupar_Mesa_de_trabajo15_2482x2481_1efc332a-63d8-467f-a9f0-214213550391.webp?v=fe78c4fc328abda8abe5774cc1b268cf"
                alt="Crescendo Digital Marketing Agency"
                className="h-10 w-auto object-contain"
              />
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/privacy-policy" className="font-body text-xs text-gray-500 hover:text-brand-green transition-colors cursor-pointer">{t("footer.privacy")}</Link>
            <Link to="/terms" className="font-body text-xs text-gray-500 hover:text-brand-green transition-colors cursor-pointer">{t("footer.terms")}</Link>
            <Link to="/cookie-policy" className="font-body text-xs text-gray-500 hover:text-brand-green transition-colors cursor-pointer">Cookies</Link>
            <Link to="/accessibility" className="font-body text-xs text-gray-500 hover:text-brand-green transition-colors cursor-pointer">Accessibility</Link>
            <a
              href="https://adrycleaningandhandymanservice.com/sitemap.xml"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-xs text-gray-500 hover:text-brand-green transition-colors cursor-pointer whitespace-nowrap"
            >
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
